import { render } from "./ClientCajasMovimientos.vue?vue&type=template&id=61c795c9"
import script from "./ClientCajasMovimientos.vue?vue&type=script&lang=js"
export * from "./ClientCajasMovimientos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__